<template>
    <div id="loaderCircle">
        <div class="load" :style="'border-top:2px solid'" ></div>
    </div>
</template>

<script>
import { mapState } from 'vuex' 
export default {
    name:'notificationCircle',
//    props:['color'],
    computed:{
        ...mapState({
            loader:(state)=>state.loader
        }),
    },
}
</script>

<style scoped>
    #loaderCircle{}
    .load{
            width: 24px;
            height: 24px;
            border: 2px solid transparent;
            border-radius: 50%;
            border-top: 2px solid transparent;
            margin: auto;
            animation: roll .3s infinite linear;
            color: #f41068;
    }
    .load:hover {
            width: 24px;
            height: 24px;
            border: 2px solid transparent;
            border-radius: 50%;
            border-top: 2px solid transparent;
            margin: auto;
            animation: roll .3s infinite linear;
            color: white;
    }
    @keyframes roll {
        0%{
            transform: rotate(0deg);
        }
        100%{
            transform: rotate(360deg);
        }
    }
</style>